import { IPlayerState } from '../reducer.types';

export const showApiRequestInitReducer = (state: IPlayerState) => ({
  ...state,
  isShowApiRequestPending: true,
  showApiRequestErrorMessage: '',
});
